import React from "react";
import "../../styles/Modal.scss";

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
const ValidationQueriesModal = ({ isOpen, onClose, validationQueries }) => {
  if (!isOpen) {
    return null;
  }
  return (
    <div className="modal">
      <div
        className="modal-content"
        style={{ minWidth: "30vw", fontSize: "12px" }}
      >
        <div className="close-button" onClick={onClose}>
          <span>&times;</span>
        </div>
        <p>
          <b>Validation Queries</b>
        </p>
        {validationQueries &&
          validationQueries.map((query, index) => (
            <div key={index} style={{ margin: "0 0 15px 0" }}>
              <strong>
                {query.question}
                <span
                  style={{
                    color:
                      query.answer === "yes"
                        ? "#00B136"
                        : query.answer === "no"
                        ? "#FF0000"
                        : "black",
                    marginLeft: "10px",
                  }}
                >
                  {capitalizeFirstLetter(query.answer)}
                </span>
              </strong>
            </div>
          ))}
      </div>
    </div>
  );
};

export default ValidationQueriesModal;
